<template>
  <section id="update-options" class="update-options-section">
    <b-container>
      <b-row>
        <b-col sm="12">
          <h4 class="title-how-works text-left">{{$t('title_how_works')}}</h4>
        </b-col>
      </b-row>
    </b-container>
    <div class="bg-section">
      <b-container class="h-530">
        <b-row class="h-100">
          <b-col sm="12" md="5">
            <div class="img-container">
              <img class="create-profile-content-img" src="../assets/img/new-content/ai-text.svg" alt="AI">
            </div>
          </b-col>
          <b-col sm="12" md="7">
            <div class="position-box">
              <div class="ai-text-content">
                <h4 class="title">{{$t("key4_title")}}</h4>
                <p class="content">{{$t("key4_text")}}</p>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </section>
</template>
<script>
export default {
  components: {
  },
  data () {
    return {
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/sass/app.scss";
.update-options-section{
  padding-top: 80px;
  @media screen and (min-width: 320px) {
    padding-top: 40px;
  }
  @media screen and (min-width: 374px) {
  }
  @media screen and (min-width: 425px) {
  }
  @media screen and (min-width: 768px) {
  }
  @media screen and (min-width: 992px) {
    padding-top: 80px;
  }
  @media screen and (min-width: 1440px) {
  }
  @media screen and (min-width: 1920px) {
  }
  .title-how-works{
    color: #30394B;
    font-family: $main-font;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%;
    margin: 0 0 40px 0;
    @media screen and (min-width: 320px) {
      font-size: 32px;
    }
    @media screen and (min-width: 768px) {

    }
    @media screen and (min-width: 992px) {
    }
    @media screen and (min-width: 1440px) {
      font-size: 40px;
    }
    @media screen and (min-width: 1920px) {
    }
  }
}
.bg-section{
  min-height: 530px;
  background: url("../assets/img/new-content/1920-ai-bg.jpg") no-repeat center center;
  background-size: 100% 100%;
  @media screen and (min-width: 320px) {
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  @media screen and (min-width: 374px) {
  }
  @media screen and (min-width: 425px) {
  }
  @media screen and (min-width: 768px) {
  }
  @media screen and (min-width: 992px) {
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  @media screen and (min-width: 1440px) {
  }
  @media screen and (min-width: 1920px) {
  }
  .h-530{
    height: 530px;
    @media screen and (min-width: 320px) {
      height: auto;
    }
    @media screen and (min-width: 374px) {
    }
    @media screen and (min-width: 425px) {
    }
    @media screen and (min-width: 768px) {
    }
    @media screen and (min-width: 992px) {
      height: 530px;
    }
    @media screen and (min-width: 1440px) {
    }
    @media screen and (min-width: 1920px) {
    }
  }
  .img-container{
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    img{
      @media screen and (min-width: 320px) {
        width: 100%;
      }
      @media screen and (min-width: 374px) {
      }
      @media screen and (min-width: 425px) {
      }
      @media screen and (min-width: 768px) {
      }
      @media screen and (min-width: 992px) {
        width: auto;
      }
      @media screen and (min-width: 1440px) {
      }
      @media screen and (min-width: 1920px) {
      }
    }
  }
  .position-box{
    height: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    @media screen and (min-width: 320px) {
      justify-content: center;
      align-items: center;
    }
    @media screen and (min-width: 374px) {
    }
    @media screen and (min-width: 425px) {
    }
    @media screen and (min-width: 768px) {
    }
    @media screen and (min-width: 992px) {
      justify-content: flex-start;
      align-items: center;
    }
    @media screen and (min-width: 1440px) {
    }
    @media screen and (min-width: 1920px) {
    }
    .ai-text-content{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      padding: 32px;
      gap: 32px;
      border-radius: 24px;
      background: rgba(255, 255, 255, 0.8);
      backdrop-filter: blur(8px);
      @media screen and (min-width: 320px) {
        padding: 24px;
        gap: 24px;
        margin-bottom: 80px;
      }
      @media screen and (min-width: 374px) {
      }
      @media screen and (min-width: 425px) {
      }
      @media screen and (min-width: 768px) {
      }
      @media screen and (min-width: 992px) {
        padding: 32px;
        gap: 32px;
        margin-bottom: 0;
      }
      @media screen and (min-width: 1440px) {
      }
      @media screen and (min-width: 1920px) {
      }
      .title{
        font-family: $main-font;
        font-size: 40px;
        font-weight: 700;
        line-height: 48px;
        text-align: left;
        margin: 0;
        @media screen and (min-width: 320px) {
          font-size: 25px;
          font-weight: 700;
          line-height: 28.4px;
        }
        @media screen and (min-width: 374px) {

        }
        @media screen and (min-width: 425px) {
        }
        @media screen and (min-width: 768px) {
        }
        @media screen and (min-width: 992px) {
          font-size: 40px;
          font-weight: 700;
          line-height: 48px;
        }
        @media screen and (min-width: 1440px) {
        }
        @media screen and (min-width: 1920px) {
        }
      }
      .content{
        font-family: $main-font;
        font-size: 18px;
        font-weight: 300;
        line-height: 25.2px;
        text-align: left;
        margin: 0;
      }
    }
  }
}
</style>
